<script setup lang="ts">import { computed as _computed } from 'vue';


import {getRuntimeEnv} from '@toolify/client/src/stores/AdminRuntimeStore/functions/getRuntimeEnv'

const webAssetsHost = getRuntimeEnv().WebAssetsHost

interface Props {
  alphaCode?: string
  width?: number
}

const props = withDefaults(defineProps<Props>(), {
  width: 16,
})

const flagLink = _computed(() => {
  if (!props.alphaCode) {
    return undefined
  }
  return `${webAssetsHost}/country-flags/${props.alphaCode.toLowerCase()}.svg`
})

const dynamicStyle = _computed(() => {
  return {
    '--width': `${props.width}px`,
  }
})
</script>

<template>
  <img
    v-if="flagLink"
    class="flag"
    :style="dynamicStyle"
    alt=""
    :src="flagLink"
  />
</template>

<style scoped lang="scss">
@use '../../../styles/variables' as variables;

.flag {
  border-radius: 50%;
  overflow: hidden;
  width: var(--width);
  height: var(--width);
  min-width: var(--width);
  min-height: var(--width);
  object-fit: cover;
  object-position: center;
}
</style>
